import { NavLink } from "hooks/useCustomNavigation";
import { INTERNAL_PATHS } from "routes/paths";
import { numberToPhone } from "utils/format";
import "./index.scss";

const { GIFT_CARD_BALANCE_CHECK } = INTERNAL_PATHS;

export const BalanceItem = ({ name, phone = null, slug }) => {
  const formattedName = `${name} Gift Card Balance`;
  return (
    <div className="gift-card-balance-item">
      <NavLink
        className="anchor-balance-item"
        to={`${GIFT_CARD_BALANCE_CHECK}/${slug}`}
      >
        {formattedName}
      </NavLink>
      {phone && (
        <p data-testid="phone-number" className="phone-balance-item">
          {numberToPhone(phone)}
        </p>
      )}
    </div>
  );
};
